import { render, staticRenderFns } from "./course_related.vue?vue&type=template&id=45ad243a&scoped=true&"
import script from "./course_related.vue?vue&type=script&lang=js&"
export * from "./course_related.vue?vue&type=script&lang=js&"
import style0 from "./course_related.vue?vue&type=style&index=0&id=45ad243a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ad243a",
  null
  
)

export default component.exports